const useRoutes = () => {
  return {
    home: '/',
    menu: '/menu',
    customer: '/customer',
    users: '/users',
    userPermissions: '/users/permissions',
    preventive: {
      configuration: '/preventive',
      preventiveForm: '/preventive/preventiveForm',
      inspectionPoints: '/inspectionPoints',
      scheduled: '/preventive/scheduled',
    },
    corrective: '/corrective',
    workOrders: '/workOrders',
    spareParts: '/spareParts',
    configuration: {
      assets: '/assets',
      section: '/section',
      machines: '/machines',
      operators: '/operators',
      warehouse: '/wareHouse',
      provider: '/providers',
    },
    holidays: '/holidays',
    vacationApprovals: '/vacationApprovals',
    orders: {
      order: '/orders',
      orderPurchase: '/orders/orderForm?isPurchase=true',
      purchase: '/orders/purchases',
    },
    invoices: {
      list: '/invoices',
      deliveryNotes: '/invoices?tab=DeliveryNotes',
      create: '/invoices/create',
      detail: '/invoices/',
      edit: (id: string) => `/invoices/${id}/edit`,
    },
    budget: {
      list: '/invoices?tab=budgets',
      create: '/invoices?tab=budgets&create=true',
      detail: (id: string) => `/budgets/${id}`,
    },
    assemblyBudget: {
      list: '/assemblyBudgets',
      detail: (id: string) => `/assemblyBudgets/${id}`,
      fieldWorkOrders: '/assemblyBudgetWorkOrders',
      workProgress: (id: string) => `/assemblyBudgetWorkOrders/${id}`,
    },
    deliveryNote: {
      list: '/deliveryNotes',
      create: '/deliveryNotes/create',
      detail: (id: string) => `/deliveryNotes/${id}`,
      edit: (id: string) => `/deliveryNotes/${id}`,
    },
    creditNote: {
      list: '/invoices?tab=creditNotes',
      detail: (id: string) => `/creditNodes/${id}`,
    },
    print: {
      workOrder: '/print/workorder',
      order: '/print/order',
      budget: (id: string) => `/print/budget?id=${encodeURIComponent(id)}`,
      assemblyBudget: (id: string) => `/print/assemblyBudget?id=${encodeURIComponent(id)}`,
    },
    accounts: '/account',
    workflows: '/system/workflows',
    production: {
      customers: '/production/customers',
      customerOrders: '/production/customerOrders',
      manufacturingOrders: '/production/manufacturingOrders',
      products: '/production/products',
    },
  };
};

export default useRoutes;
